import React, { useContext, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import classNames from "classnames";
import { useMsal } from "@azure/msal-react";
import { AppDB } from "./App";
import { Dropdown } from "primereact/dropdown";
import { changeLang } from "./componets/Language/ChangeLang";
import { Button } from "primereact/button";
// changeLang
export const AppTopbar = (props) => {
    const { instance } = useMsal();
    var { applicationName ,menuRootName} = useContext(AppDB)
    var [language, setLanguage] = useState([
        { key: "English", value: "./lang/english.json" },
        { key: "Other", value: "./lang/other.json" }
    ])
    var [selectedLang, setSelectedLang] = useState(null)
    function Logout() {
        localStorage.removeItem("central-site-token");
        localStorage.removeItem("central-site-user")
        localStorage.removeItem("central-site-delimitation")

        // localStorage.clear();
        instance.logoutRedirect().catch((error) => console.log(error));
        //window.location.reload();
    }

    useEffect(() => {
        var l = localStorage.getItem("language")
        if (l) {
            changeLang.load(l)
            setSelectedLang(l)
        } else {
            if (language.length > 0) {
                changeLang.change(language.at(0).value)
                setSelectedLang(language.at(0).value)
            }
        }
    }, [])

    return (
        <div className="layout-topbar">
            <Link to="/" className="layout-topbar-logo">
                <img src={props.layoutColorMode === "light" ? "assets/layout/images/newlogo2.png" : "assets/layout/images/newlogo2.png"} alt="logo" />
                <span style={{ fontSize: 16 }}>{applicationName} - {menuRootName?.parentLabel}</span>
            </Link>

            <button type="button" className="p-link  layout-menu-button layout-topbar-button" onClick={props.onToggleMenuClick}>
                <i className="pi pi-bars" />
            </button>

            <button type="button" className="p-link layout-topbar-menu-button layout-topbar-button" onClick={props.onMobileTopbarMenuClick}>
                <i className="pi pi-ellipsis-v" />
            </button>

            <ul className={classNames("layout-topbar-menu lg:flex origin-top", { "layout-topbar-menu-mobile-active": props.mobileTopbarMenuActive })}>
                {/* <li>
                    <button className="p-link layout-topbar-button" onClick={props.onMobileSubTopbarMenuClick}>
                        <i className="pi pi-cog" />
                        <span>Settings</span>
                    </button>
                </li> */}
                <li>
                    {/* <button className="p-link layout-topbar-button" onClick={props.onMobileSubTopbarMenuClick}>
                        <i className="pi pi-user" />
                        <span>Profile</span>
                    </button> */}
                    <Button
                       
                        style={{color:"white",pointerEvents:"none"}}
                        className="p-button-info user-profile vimeo p-p-2 p-mr-2 p-button-outlined  p-link w-full"
                    >
                        <i className="pi pi-user p-px-1 "></i>
                        <span className="p-px-3 ml-3">{props?.azureLoginState?.data?.username ||"No Name"}</span>
                       
                    </Button>
                </li>
                <li>
                    <button className="p-link layout-topbar-button" onClick={Logout}>
                        <i className="pi  pi-sign-out" />
                        <span>Logout</span>
                    </button>
                </li>

                {/* <li>
                    <Dropdown value={selectedLang} onChange={e => {
                        setSelectedLang(e.value)
                        changeLang.change(e.value)
                    }
                    } optionValue="value" optionLabel="key" options={language} />

                </li> */}
            </ul>
        </div>
    );
};
